import { default as Modal } from 'antd/es/modal';

import type { IntegrationBusinessUnit } from 'api';

import { PrimaryButton } from '@atoms/buttons/PrimaryButton';
import { SecondaryButton } from '@atoms/buttons/SecondaryButton';

import {
  SET_DEFAULT_CANCEL_TEST_ID,
  SET_DEFAULT_CONFIRM_LABEL,
  SET_DEFAULT_CONFIRM_TEST_ID,
  SET_DEFAULT_MODAL_TEST_ID,
  SET_DEFAULT_MODAL_WIDTH,
  SET_DEFAULT_TITLE,
  setDefaultBody
} from './constants';
import { useSetDefaultBusinessUnit } from './useSetDefaultBusinessUnit';

type SetDefaultBusinessUnitModalProps = {
  businessUnit: IntegrationBusinessUnit;
  open: boolean;
  onCancel: () => void;
  onConfirmed: () => void;
};

export const SetDefaultBusinessUnitModal = ({
  businessUnit,
  open,
  onCancel,
  onConfirmed
}: SetDefaultBusinessUnitModalProps) => {
  const { setDefault, isPending } = useSetDefaultBusinessUnit();

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      width={SET_DEFAULT_MODAL_WIDTH}
      destroyOnHidden
      title={
        <div className="text-lg font-medium text-content-primary">
          {SET_DEFAULT_TITLE}
        </div>
      }
      footer={
        <div className="flex justify-end gap-2">
          <SecondaryButton
            data-testid={SET_DEFAULT_CANCEL_TEST_ID}
            onClick={onCancel}
            disabled={isPending}
          >
            Cancel
          </SecondaryButton>
          <PrimaryButton
            data-testid={SET_DEFAULT_CONFIRM_TEST_ID}
            loading={isPending}
            onClick={() => setDefault(businessUnit.uuid, onConfirmed)}
          >
            {SET_DEFAULT_CONFIRM_LABEL}
          </PrimaryButton>
        </div>
      }
    >
      <p
        data-testid={SET_DEFAULT_MODAL_TEST_ID}
        className="text-base text-content-primary"
      >
        {setDefaultBody(businessUnit.name)}
      </p>
    </Modal>
  );
};
